export type IsoCertificateCode =
  | "iso-9001"
  | "iso-14001"
  | "iso-27001"
  | "iso-27701";

export type IsoCertificateStandard =
  | "iso-9001-14001"
  | "iso-27001-27701";

export type IsoCertificateDocument = {
  id: number;
  codigo: IsoCertificateCode;
  nombre_original: string;
  mime_type: string | null;
  tamano_bytes: number | null;
  usuario_modificacion_id: number | null;
  usuario_modificacion_nombre: string | null;
  created_at: string | null;
  updated_at: string | null;
};

export type IsoCertificateSlot = {
  codigo: IsoCertificateCode;
  standard: IsoCertificateStandard;
  label: string;
  available: boolean;
  documento: IsoCertificateDocument | null;
};

export type IsoCertificatesResponse = {
  data: IsoCertificateSlot[];
  can_manage: boolean;
};

export const isoCertificateCodesByStandard: Record<
  IsoCertificateStandard,
  IsoCertificateCode[]
> = {
  "iso-9001-14001": ["iso-9001", "iso-14001"],
  "iso-27001-27701": ["iso-27001", "iso-27701"],
};

export const isoCertificateLabels: Record<IsoCertificateCode, string> = {
  "iso-9001": "Certificado ISO 9001",
  "iso-14001": "Certificado ISO 14001",
  "iso-27001": "Certificado ISO 27001",
  "iso-27701": "Certificado ISO 27701",
};

export function createEmptyIsoCertificateSlot(
  codigo: IsoCertificateCode,
  standard: IsoCertificateStandard,
): IsoCertificateSlot {
  return {
    codigo,
    standard,
    label: isoCertificateLabels[codigo],
    available: false,
    documento: null,
  };
}
